const routes = [
  {
    path: '/:pathMatch(.*)*', 
    redirect: '/error/404',
  },
]

export default routes
